import React, { useEffect, useState } from "react";
import styles from "./inventryreport.module.css";
import TopTabBar from "../../components/updatedComponents/Tanolet/TopTabBar";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../../components/context/Auth";
import InputTypedate from "../../components/updatedComponents/FormComponents/InputTypedate";
import SlidingFilter2 from "../../components/updatedComponents/Dealers/SlidingFilter2";
import SlidingFilter from "../../components/updatedComponents/Dealers/SlidingFilter";
import Spinner from "../../components/updatedComponents/FormComponents/Spinner";
import SearchBar from "../../components/updatedComponents/FormComponents/SearchBar";
const Inventrycollectionitemmodal = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const collection_id = location.state?.collection_id;
  const productId = location.state?.product_id;
  const item_id = location.state?.item_id;
  const itemNo = location.state?.itemNo;
  console.log("item_id", item_id);
  const { managerId } = useAuth();
  const [data, setData] = useState([]);
  const [daysTab, setDaysTab] = useState("");
  const [inout, setInout] = useState("");
  const [loading, setLoading] = useState(false);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [itemSearch, setItemSearch] = useState("");
  const { mode } = useAuth();
  // const orderHeader = ["Quantity", "Rate", "Value"];
  const orderHeader1 = [
    itemNo,
    "Adjustment Qty",
    "Rate",
    "Value",
    "Inward Qty",
    "Rate",
    "Value",
    "Outward Qty",
    "Rate",
    "Value",
    "Opening Qty",
    "Rate",
    "Value",
    "Closing Qty",
    "Rate",
    "Value",
  ];
  const orderHeader2 = [
    "Grand Total",
    "Adjustment Qty",
    "Rate",
    "Value",
    "Inward Qty",
    "Rate",
    "Value",
    "Outward Qty",
    "Rate",
    "Value",
    "Opening Qty",
    "Rate",
    "Value",
    "Closing Qty",
    "Rate",
    "Value",
  ];
  const dayOptions = [
    {
      value: "",
      label: "All",
    },
    {
      value: "Disable",
      label: "Inside",
    },
    {
      value: "Active",
      label: "Outside ",
    },
  ];
  const dayOptions1 = [
    {
      value: "today",
      label: "Today",
    },
    {
      value: "yesterday",
      label: "Yesterday",
    },
    {
      value: "month",
      label: "This Month ",
    },
  ];
  const handleDayChange = (label) => {
    const selectedFilter = dayOptions.find((item) => item.label === label);
    setInout(selectedFilter?.value || "all");
  };
  const handleDayChange1 = (label) => {
    const selectedFilter1 = dayOptions1.find((item) => item.label === label);
    setDaysTab(selectedFilter1?.value || "today");
  };
  const getitems = () => {
    setLoading(true);

    var myHeaders = new Headers();
    myHeaders.append("wa-platform", process.env.REACT_APP_ADMIN_SECRET);
    myHeaders.append("Content-Type", "application/json");

    const raw = JSON.stringify({
      managerId: managerId,
      item_id: item_id,
      searchKeyword: itemSearch,
      outsourcedItem: inout,
      day: daysTab,
      startDate: startDate ? startDate : "",
      endDate: endDate ? endDate : "",
    });

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };
    fetch(process.env.REACT_APP_URL + "inventory/monthlyItems", requestOptions)
      .then((response) => {
        return response.json();
      })
      .then((result) => {
        if (result.status === "success") {
          setLoading(false);

          setData(result?.data);
          console.log("data",result.data);

        } else {
          console.error("API Response Error:", result);
        }
      })
      .catch((error) => console.error("Fetch Error:", error))
      .finally(() => {
        setLoading(false);
      });
  };
  useEffect(() => {
    getitems();
  }, [
    startDate,
    endDate,
    itemSearch,
    collection_id,
    productId,
    item_id,
    daysTab,
    inout,
  ]);
  
  return (
    <React.Fragment>
      <div
        style={{ backgroundColor: mode ? "#232529" : "#D9DCE5" }}
        className={styles.main}
      >
        <div
          className={`${styles.mainCon} ${
            mode ? styles.mainConDark : styles.mainConLight
          }`}
        >
          <div className={styles.order_top}>
            <div className={styles.order_top_left}>
              <TopTabBar text={"Inventory Report"} />
            </div>
            <div className={styles.order_right}>
              <div>
                <SlidingFilter2
                  itemList={dayOptions.map((item) => item.label)}
                  setFilter={handleDayChange}
                  selectedItem={
                    dayOptions.find((item) => item.value === inout)?.label
                  }
                />
              </div>
              <div>
                <SlidingFilter
                  itemList={dayOptions1.map((item) => item.label)}
                  setFilter={handleDayChange1}
                  selectedItem={
                    dayOptions1.find((item) => item.value === daysTab)?.label
                  }
                />
              </div>
              <div>
                <InputTypedate
                  text={"From"}
                  onChange={(e) => {
                    setStartDate(e.target.value);
                    setDaysTab("");
                  }}
                />
              </div>
              <div>
                <InputTypedate
                  text={"To"}
                  onChange={(e) => {
                    setEndDate(e.target.value);
                    setDaysTab("");
                  }}
                />
              </div>
            </div>
          </div>
          <div className={styles.inventory_search_bar}>
            <SearchBar
              placeholder={"Search by Collection"}
              value={itemSearch}
              onChange={(e) => setItemSearch(e.target.value)}
            />
          </div>
          <div className={styles.tablemain1}>
            <ul className={styles.order_data_list}>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  borderRadius: "3px",
                }}
              >
                {" "}
                <li
                  className={`${styles.order_data_list_row_header12} ${
                    mode ? styles.order_data_list_row_header_dark : ""
                  }`}
                >
                  {orderHeader1.map((h) => (
                    <div
                      style={{ textAlign: "center" }}
                      className={styles.entry}
                      key={h}
                    >
                      {h}
                    </div>
                  ))}
                </li>
              
              </div>
              <div className={styles.order_data_list_container12}>
                {loading ? (
                  <div style={{ margin: "1rem auto" }}>
                    <Spinner height={80} width={80} />
                  </div>
                ) : data?.data?.length === 0 ? (
                  <img
                    src="/assets/updatedAssets/noDATA.png"
                    alt="img"
                    style={{
                      height: "12rem",
                      width: "16rem",
                      margin: "1rem auto",
                    }}
                  />
                ) : (
                  <>
                    {data?.monthlyData?.map((d, i) => (
                      <li
                        style={{ textAlign: "center" , cursor:"pointer"}}
                        key={i}
                        className={`${styles.order_data_list_row2} ${
                          mode ? styles.order_data_list_row_dark : ""
                        }`}
                        // onClick={() => {
                        //   navigate("/", {
                        //     state: {
                        //       item_id: d?._id,
                        //       product_id: d?.product_id,
                        //     },
                        //   });
                        // }}
                      >
                        <div className={styles.entry}>{d.month}</div>
                        <div className={styles.entry}>
                          {d.adjustment.quantity}
                        </div>
                        <div className={styles.entry}>{d.adjustment.rate}</div>
                        <div className={styles.entry}>{d.adjustment.value}</div>
                        <div className={styles.entry}>{d.inward.quantity}</div>
                        <div className={styles.entry}>{d.inward.rate}</div>
                        <div className={styles.entry}>{d.inward.value}</div>
                        <div className={styles.entry}>{d.outward.quantity}</div>
                        <div className={styles.entry}>{d.outward.rate}</div>
                        <div className={styles.entry}>{d.outward.value}</div>
                        <div className={styles.entry}>{d.opening.quantity}</div>
                        <div className={styles.entry}>{d.opening.rate}</div>
                        <div className={styles.entry}>{d.opening.value}</div>
                        <div className={styles.entry}>{d.closing.quantity}</div>
                        <div className={styles.entry}>{d.closing.rate}</div>
                        <div className={styles.entry}>{d.closing.value}</div>
                      </li>
                    ))}
                  </>
                )}
              </div>
            </ul>
          </div>
          <div
            style={{
              backgroundColor: mode ? "#2C2E33CC" : " white",
              left: "0",
              color: mode ? "white" : "black",
            }}
            className={styles.button_div1}
          >
            <div
              className={styles.btn_flex1}
              style={{ color: mode ? "white" : " black" }}
            >
              {/* <li  style={{
            gap:"30px",textAlign:"center", width:"100%"
            }} className={styles.grand_total_list1}>
                <div    >Grand Total</div>
                <div >Grand Total</div>
                <div >Grand Total</div>
                <div >Grand Total</div>
                <div >Grand Total</div>
                <div >Grand Total</div>
                <div >Grand Total</div>
                <div >Grand Total</div>
                <div >Grand Total</div>
                <div >Grand Total</div>
                <div >Grand Total</div>
                <div >Grand Total</div>
                <div >Grand Total</div>
         
             
              </li> */}
               <div className={styles.bottomtable}>
                {/* <ul className={styles.bottomul}>
                  <li
                    style={{
                      backgroundColor: mode ? "#2B2D31" : "",
                    }}
                    className={`${styles.order_data_list_row_header} ${
                      mode ? styles.order_data_list_row_header_dark : ""
                    }`}
                  >
                    {orderHeader2.map((h) => (
                      <div className={styles.entry} key={h}>
                        {h}
                      </div>
                    ))}
                  </li>
                </ul> */}

                <ul
                  className={styles.bottomu2}
                  style={{
                    minHeight: "5vh",
                    maxHeight: "10vh",
                    // paddingLeft:"20px"
                  }}
                >
                    <li
                      style={{
                        backgroundColor: mode ? "#1C1D21" : "#F8F9FC",
                       gap:"28px" 
                      }}
                      className={`${styles.order_data_list_row2} ${
                        mode ? styles.order_data_list_row_dark : ""
                      }`}
                    >
                      <div className={styles.entry}>Grandtotal</div>
                      <div  style={{marginLeft:"55px"}} className={styles.entry}> {data?.grandTotal?.adjustment?.quantity }</div>
                      <div  className={styles.entry}> {data?.grandTotal?.adjustment?.rate }</div>
                      {/* <div className={styles.entry}>{data.grandTotal.adjustment.quantity}</div> */}
                      <div className={styles.entry}>  {data?.grandTotal?.adjustment?.value }
</div>
                      <div className={styles.entry}> {data?.grandTotal?.inward?.quantity }</div>
                      <div className={styles.entry}> {data?.grandTotal?.inward?.rate }</div>
                      <div className={styles.entry} >{data?.grandTotal?.inward?.value }</div>
                      <div className={styles.entry}> {data?.grandTotal?.outward?.quantity }</div>
                      <div className={styles.entry}> {data?.grandTotal?.outward?.rate }</div>
                      <div className={styles.entry} >{data?.grandTotal?.outward?.value }</div>
                      <div className={styles.entry}> {data?.grandTotal?.opening?.quantity }</div>
                      <div className={styles.entry}> {data?.grandTotal?.opening?.rate }</div>
                      <div className={styles.entry} >{data?.grandTotal?.opening?.value }</div>
                      <div className={styles.entry}> {data?.grandTotal?.closing?.quantity }</div>
                      <div className={styles.entry}> {data?.grandTotal?.closing?.rate }</div>
                      <div className={styles.entry} >{data?.grandTotal?.closing?.value }</div>
                 
                      {/* <div style={{ paddingLeft: "15px" }}className={styles.entry}>
                       
                      </div> */}
                    </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default Inventrycollectionitemmodal;
